import * as React from 'react';

export const ConfirmSaveComponent = () => (
  <div className="row middle-xs center-xs">
    <h2>Save the contract and continue to payment?</h2>
  </div>
);



// WEBPACK FOOTER //
// ./src/contract/_components/summary/confirm-save.component.tsx